import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caf51276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "topBox"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "van-ellipsis roomTitle"
}
const _hoisted_6 = {
  key: 0,
  class: "center"
}
const _hoisted_7 = {
  style: {"font-size":"13px"},
  class: "van-ellipsis"
}
const _hoisted_8 = {
  style: {"font-size":"10px"},
  class: "van-ellipsis"
}
const _hoisted_9 = {
  key: 1,
  class: "right-follow"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "right"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "newbox"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "moviebox"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "cont"
}
const _hoisted_21 = { class: "enc-content" }
const _hoisted_22 = {
  class: "team_logo",
  alt: ""
}
const _hoisted_23 = { class: "team_name" }
const _hoisted_24 = {
  class: "enc-content",
  style: {"width":"40vw"}
}
const _hoisted_25 = {
  key: 0,
  class: "enc-score"
}
const _hoisted_26 = {
  key: 1,
  class: "enc-time",
  style: {"margin-right":"10px"}
}
const _hoisted_27 = { style: {"font-size":"10px"} }
const _hoisted_28 = { class: "enc-content" }
const _hoisted_29 = {
  class: "team_logo",
  alt: ""
}
const _hoisted_30 = { class: "team_name" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "subTitle" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 0,
  class: "noticebar",
  style: {"height":"20px"}
}
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "downBox",
  style: { height: '35px' }
}
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 2,
  class: "downBox",
  style: { height: '35px', }
}
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "tab-title-with-dot" }
const _hoisted_45 = {
  key: 0,
  class: "red-dot"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "updateDownload" }
const _hoisted_51 = {
  class: "bg",
  alt: ""
}
const _hoisted_52 = { class: "con" }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = { class: "title" }
const _hoisted_55 = { class: "centerBox" }
const _hoisted_56 = { class: "money" }
const _hoisted_57 = { class: "right" }
const _hoisted_58 = ["src"]
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "tips" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "matchShareBox" }
const _hoisted_63 = { class: "bg" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "van-ellipsis link" }
const _hoisted_66 = { class: "shareBtn" }
const _hoisted_67 = ["src"]
const _hoisted_68 = ["onClick", "src"]
const _hoisted_69 = { class: "info" }
const _hoisted_70 = { class: "namebox" }
const _hoisted_71 = { class: "name van-ellipsis" }
const _hoisted_72 = { class: "msg" }
const _hoisted_73 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createCommentVNode(" 顶部视频 "),
        (!$setup.isNoUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "navBar",
                style: _normalizeStyle({
        backgroundColor: ($setup.liveUrl == '' && $setup.match_data) ? '#2F2F2F' : '#000000',
        height: $setup.getHeaderHei() + 'px'
      })
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: $setup.back,
                    onClick: $setup.backRouter,
                    alt: "",
                    class: "anvback"
                  }, null, 8 /* PROPS */, _hoisted_4),
                  (!($setup.liveUrl == '' && $setup.match_data))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.roomTitle), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                ($setup.liveUrl == '' && $setup.match_data)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString($setup.match_data.short_name_zh), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_8, _toDisplayString($setup.formatDate($setup.match_data.match_time, "YYYY/MM/DD HH:mm"
      )), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.liveUrl == '' && $setup.match_data)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      ($setup.match_data.is_follow)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: $setup.yidingyue,
                            alt: "",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.toDingyue(0)), ["stop"]))
                          }, null, 8 /* PROPS */, _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: $setup.dingyue_icon,
                            alt: "",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.toDingyue(1)), ["stop"]))
                          }, null, 8 /* PROPS */, _hoisted_11))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (!$setup.standalone && $setup.Platform.client == 'h5')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "changeHz",
                            onClick: $setup.toAZ,
                            src: $setup.touping,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_13))
                        : _createCommentVNode("v-if", true),
                      ($setup.checkApp())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("img", {
                              class: "changeHz",
                              src: $setup.playhz,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.alertDown = true)),
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_15),
                            _createCommentVNode(" <img class=\"new\" src=\"@/assets/images/new.png\" alt=\"\"> ")
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" <img class=\"changeLine\" v-if=\"liveUrlList.length > 0\" :src=\"changeLine\" @click=\"changeLineFn\" alt=\"\" /> "),
                      _createElementVNode("div", {
                        class: "changeLineButton",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openLiveUrlBox = !$setup.openLiveUrlBox))
                      }, [
                        _createElementVNode("img", {
                          src: $setup.changeLine,
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_16)
                      ])
                    ]))
              ], 4 /* STYLE */),
              ($setup.liveUrl !== '' && $setup.liveStatus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (!$setup.ios)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 0,
                          id: "playiframe",
                          src: $setup.videoUrl + '?poster=' + $setup.live_load_img + '&ad=' + JSON.stringify($setup.openAd),
                          style: {"height":"100%","width":"100%"},
                          allow: "autoplay",
                          scrolling: "no",
                          frameBorder: "0",
                          allowFullScreen: ""
                        }, null, 8 /* PROPS */, _hoisted_18))
                      : _createCommentVNode("v-if", true),
                    ($setup.count > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "adBox",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.toImg($setup.adData.url)))
                        }, [
                          _createElementVNode("img", {
                            src: $setup.adData.img,
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_19),
                          ($setup.showInterval)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.count) + " s", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : ($setup.match_data)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "noOnLiveScore",
                      style: _normalizeStyle({ backgroundImage: 'url(' + ($setup.match_type == '1' ? $setup.football_bg : $setup.basketball_bg) + ')' })
                    }, [
                      _createCommentVNode(" 足球 "),
                      _createElementVNode("div", _hoisted_21, [
                        _withDirectives(_createElementVNode("img", _hoisted_22, null, 512 /* NEED_PATCH */), [
                          [_directive_lazy, $setup.match_data.home_log]
                        ]),
                        _createElementVNode("div", _hoisted_23, _toDisplayString($setup.match_data.home_name + ($setup.match_type == '1' ? "" : "(" + _ctx.$t('play.zhu') + ")")), 1 /* TEXT */)
                      ]),
                      _createCommentVNode(" 中 "),
                      _createElementVNode("div", _hoisted_24, [
                        (($setup.match_data.status_id > 1))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("span", null, _toDisplayString($setup.Match.getHomeScore($setup.match_data) + " : " + $setup.Match.getAwayScore($setup.match_data)), 1 /* TEXT */)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('play.disstartmatch')), 1 /* TEXT */),
                              _createVNode(_component_van_count_down, {
                                style: {"font-size":"20px","color":"#fff","margin-top":"5px"},
                                time: ($setup.match_data['match_time'] * 1000 - Date.now())
                              }, null, 8 /* PROPS */, ["time"])
                            ]))
                      ]),
                      _createCommentVNode(" 右 "),
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("img", _hoisted_29, null, 512 /* NEED_PATCH */), [
                          [_directive_lazy, $setup.match_data.away_log]
                        ]),
                        _createElementVNode("div", _hoisted_30, _toDisplayString($setup.match_data.away_name + ($setup.match_type == '1' ? "" : "(" + _ctx.$t('play.ke') + ")")), 1 /* TEXT */)
                      ])
                    ], 4 /* STYLE */))
                  : ($setup.match_data && $setup.match_type == '2')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "noOnLiveScore",
                        style: _normalizeStyle({ backgroundImage: 'url(' + $setup.basketball_bg + ')' })
                      }, [
                        _createCommentVNode(" 篮球 ")
                      ], 4 /* STYLE */))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "noOnLive",
                        style: _normalizeStyle({ backgroundColor: ($setup.liveUrl == '' && $setup.match_data) ? '#2F2F2F' : '#000000' })
                      }, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("play.zbNoLine")), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("play.zbNoLine2")), 1 /* TEXT */)
                      ], 4 /* STYLE */))
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" 没源的 "),
        ($setup.isNoUrl && $setup.coverData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode($setup["Cover"], {
                data: { coverData: $setup.coverData }
              }, null, 8 /* PROPS */, ["data"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" 滚动条 "),
      ($setup.noticebarText !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("img", { src: $setup.gift }, null, 8 /* PROPS */, _hoisted_35),
            _createVNode(_component_van_notice_bar, {
              speed: "25",
              onClick: $setup.clickNoticebarText,
              color: $setup.marqueeFontColor,
              background: $setup.marqueeColor,
              text: $setup.noticebarText
            }, null, 8 /* PROPS */, ["color", "background", "text"])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.is_show_up68_copy_share && $setup.isNoUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("img", {
              style: _normalizeStyle($setup.th == 'th' ? { width: '48%', height: '90%' } :
        { width: '146px', position: 'relative', left: '1px' }
        ),
              src: $setup.down68,
              onClick: $setup.click68,
              alt: "下载68"
            }, null, 12 /* STYLE, PROPS */, _hoisted_37),
            _createElementVNode("img", {
              style: _normalizeStyle($setup.th == 'th' ? { width: $setup.th == 'th' ? '26%' : '32%', height: '85%', marginRight: $setup.th == 'th' ? '6px' : '0px' } :
        { width: '68px', position: 'relative', left: '7px' }
        ),
              src: $setup.copyidimg,
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.copyclsaa('copyID', $setup.copyid))),
              class: "copyID",
              alt: "copyID"
            }, null, 12 /* STYLE, PROPS */, _hoisted_38),
            _createElementVNode("img", {
              style: _normalizeStyle($setup.th == 'th' ? { width: $setup.th == 'th' ? '16%' : '20%', height: '80%', marginRight: $setup.th == 'th' ? '3px' : '0px' } :
        { width: '52px', position: 'relative', left: '9px' }
        ),
              src: $setup.shareImg,
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.onclickSharel())),
              alt: ""
            }, null, 12 /* STYLE, PROPS */, _hoisted_39)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 下载68 "),
      ($setup.is_show_up68_copy_share && $setup.th != 'th' && !$setup.isNoUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("img", {
              style: _normalizeStyle($setup.th == 'th' ? { width: '48%', height: '90%' } :
        { width: '146px', position: 'relative', left: '1px' }
        ),
              src: $setup.down68,
              onClick: $setup.click68,
              alt: "下载68"
            }, null, 12 /* STYLE, PROPS */, _hoisted_41),
            _createElementVNode("img", {
              style: _normalizeStyle($setup.th == 'th' ? { width: $setup.th == 'th' ? '26%' : '32%', height: '85%', marginRight: $setup.th == 'th' ? '6px' : '0px' } :
        { width: '73px', position: 'relative', left: '11px', top: '1px' }
        ),
              src: $setup.copyidimg,
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.copyclsaa('copyID', $setup.copyid))),
              class: "copyID",
              alt: "copyID"
            }, null, 12 /* STYLE, PROPS */, _hoisted_42),
            _createElementVNode("img", {
              style: _normalizeStyle($setup.th == 'th' ? { width: $setup.th == 'th' ? '16%' : '20%', height: '80%', marginRight: $setup.th == 'th' ? '3px' : '0px' } :
        { width: '55px', position: 'relative', left: '9px' }
        ),
              src: $setup.shareImg,
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.onclickSharel())),
              alt: ""
            }, null, 12 /* STYLE, PROPS */, _hoisted_43)
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_van_tabs, {
        id: "playerTabs",
        "line-width": "0px",
        color: $setup.primaryColor,
        style: _normalizeStyle({ height: $setup.tabsHeight() + 'px' }),
        onChange: $setup.onChange,
        "before-change": $setup.beforeChange
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" <template #nav-right>\n        <div class=\"nav-right\">\n          <img src=\"@/assets/images/sharlMatch.png\" @click=\"onclickSharel()\" />\n        </div>\n      </template> "),
          _createCommentVNode(" 聊天 "),
          (!$setup.offChat &&
        $setup.roomdata &&
        $setup.roomdata.groupId &&
        $setup.roomdata.groupId != '' &&
        $setup.roomdata.groupId != '0'
        )
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 0,
                name: "chatroom",
                title: $setup.t('play.chat')
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["PlayChat"], {
                    setdata: $setup.roomdata.set_data,
                    height: $setup.tabsHeight() - 108
                  }, null, 8 /* PROPS */, ["setdata", "height"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 主播私聊 "),
          ($setup.zb_chatkey)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 1,
                name: "private_chat"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", null, _toDisplayString($setup.t('主播私聊')), 1 /* TEXT */),
                    ($setup.privateChatRedDot)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode($setup["PlayerPrivateChat"], {
                    roomdata: $setup.roomdata,
                    "auto-msg": $setup.assistanceAutoMsg
                  }, null, 8 /* PROPS */, ["roomdata", "auto-msg"])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 群组 "),
          _createVNode(_component_van_tab, {
            name: "group_chat",
            title: $setup.t('群组')
          }, {
            default: _withCtx(() => [
              _createVNode($setup["PlayerGroupChat"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]),
          _createCommentVNode(" 主播 "),
          ($setup.roomdata && $setup.liveType == '4')
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 2,
                name: "anchor",
                title: $setup.t('play.userzb')
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["Anchor"], {
                    roomdata: $setup.roomdata,
                    onChatClick: $setup.onChatZhuboClick
                  }, null, 8 /* PROPS */, ["roomdata"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 赛况 "),
          ($setup.hasUrl && $setup.liveType != '4' && $setup.roomdata&& $setup.roomdata.type_id != 3001)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 3,
                name: "saikuang",
                title: $setup.t('play.saik')
              }, {
                default: _withCtx(() => [
                  ($setup.match_type == '2')
                    ? (_openBlock(), _createBlock($setup["Basketball"], {
                        key: 0,
                        roomdata: $setup.roomdata
                      }, null, 8 /* PROPS */, ["roomdata"]))
                    : (_openBlock(), _createBlock($setup["Football"], {
                        key: 1,
                        roomdata: $setup.roomdata
                      }, null, 8 /* PROPS */, ["roomdata"]))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 阵容 "),
          ($setup.hasUrl && $setup.liveType != '4' && $setup.is_has_player_stats)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 4,
                name: "team",
                title: $setup.t('play.zr')
              }, {
                default: _withCtx(() => [
                  ($setup.match_type == '2')
                    ? (_openBlock(), _createBlock($setup["TameBasketball"], {
                        key: 0,
                        type: $setup.match_type,
                        id: $setup.match_id,
                        roomdata: $setup.roomdata
                      }, null, 8 /* PROPS */, ["type", "id", "roomdata"]))
                    : (_openBlock(), _createBlock($setup["TeamFootball"], {
                        key: 1,
                        type: $setup.match_type,
                        id: $setup.match_id,
                        roomdata: $setup.roomdata
                      }, null, 8 /* PROPS */, ["type", "id", "roomdata"]))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 指数 "),
          ($setup.is_has_history && $setup.match_type != '' && !$setup.is_lb)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 5,
                name: "index",
                title: $setup.t('play.zs')
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["Zhishu"], {
                    type: $setup.match_type,
                    id: $setup.match_id
                  }, null, 8 /* PROPS */, ["type", "id"]),
                  _createCommentVNode(" <ZhishuFootball v-else :type=\"match_type\" :id=\"match_id\"></ZhishuFootball> ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 分析 "),
          ($setup.is_has_intelligence && $setup.match_type != '' && !$setup.is_lb)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 6,
                name: "fenxi",
                title: $setup.t('play.fx')
              }, {
                default: _withCtx(() => [
                  ($setup.match_type == '2')
                    ? (_openBlock(), _createBlock($setup["BasketBallFenxi"], {
                        key: 0,
                        type: $setup.match_type,
                        id: $setup.match_id
                      }, null, 8 /* PROPS */, ["type", "id"]))
                    : (_openBlock(), _createBlock($setup["FootballFenxi"], {
                        key: 1,
                        type: $setup.match_type,
                        id: $setup.match_id
                      }, null, 8 /* PROPS */, ["type", "id"]))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 直播 "),
          ($setup.is_show_host && $setup.liveType == '4')
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 7,
                name: "live",
                title: $setup.t('play.zb')
              }, {
                default: _withCtx(() => [
                  _createVNode($setup["Live"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 私信 "),
          _createCommentVNode(" <van-tab name=\"sixin\" :title=\"t('play.sixin')\" v-if=\"liveType == '4' && zb_chatkey && zb_chatkey != ''\">\n        <MessageChat :id=\"zb_chatkey + ''\" :auto-msg=\"zb_autoMsg\" />\n      </van-tab> "),
          ($setup.roomdata && $setup.roomdata.free_id && $setup.liveType != '4')
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 8,
                name: "zhuboinfo"
              }, {
                title: _withCtx(() => [
                  ($setup.roomdata && $setup.roomdata.free_id)
                    ? (_openBlock(), _createBlock($setup["AnchorTab"], {
                        key: 0,
                        type: 1,
                        roomdata: $setup.roomdata
                      }, null, 8 /* PROPS */, ["roomdata"]))
                    : _createCommentVNode("v-if", true)
                ]),
                default: _withCtx(() => [
                  _createVNode($setup["Anchor"], { roomdata: $setup.roomdata }, null, 8 /* PROPS */, ["roomdata"])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" <van-tab name=\"chatzhubo\" v-if=\"zb_chatkey && zb_chatkey != '' && liveType != '4'\">\n        <template #title>\n          <AnchorTab :type=\"2\" v-if=\"roomdata && roomdata.free_id\" :roomdata=\"roomdata\" />\n        </template>\n        <MessageChat :id=\"zb_chatkey + ''\" :auto-msg=\"zb_autoMsg\" />\n      </van-tab> ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["color", "style"])
    ]),
    _createCommentVNode(" alertDown "),
    _createCommentVNode(" <van-overlay :show=\"alertDown\" @click=\"alertDown = false\" z-index=\"99999\">\n    <div class=\"wrapper\" @click.stop>\n      <img class=\"bg\" :src=\"arterBg\" alt=\"\" />\n      <img class=\"btn\" :src=\"arterBtn\" @click=\"fnDownApp()\" alt=\"\" />\n      <img class=\"offbtn\" :src=\"offArterBtn\" alt=\"\" @click=\"alertDown = false\" />\n    </div>\n  </van-overlay> "),
    _createCommentVNode(" alertDown "),
    (!$setup.standalone && $setup.alertDown && !$setup.liveTimeDownload)
      ? (_openBlock(), _createBlock(_component_van_overlay, {
          key: 0,
          show: !$setup.standalone && $setup.alertDown && !$setup.liveTimeDownload,
          "z-index": "99999"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass($setup.app_name == 'vi' ? 'liveTimeDownload_vi' : 'liveTimeDownload'),
              onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
              style: _normalizeStyle({ backgroundImage: 'url(' + $setup.liveTimeDownloadBg + ')' })
            }, [
              _createElementVNode("img", {
                class: "btn",
                src: $setup.liveTimeDownloadBtn,
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.toDownloadApp())),
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_46),
              _createElementVNode("img", {
                class: "offbtn",
                src: $setup.offArterBtn,
                alt: "",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.closeAlertDown()))
              }, null, 8 /* PROPS */, _hoisted_47)
            ], 6 /* CLASS, STYLE */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["show"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" live time to download "),
    (!$setup.standalone && $setup.liveTimeDownload)
      ? (_openBlock(), _createBlock(_component_van_overlay, {
          key: 1,
          show: !$setup.standalone && $setup.liveTimeDownload,
          "z-index": "99999"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass($setup.app_name == 'vi' ? 'liveTimeDownload_vi' : 'liveTimeDownload'),
              onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
              style: _normalizeStyle({ backgroundImage: 'url(' + $setup.liveTimeDownloadBg + ')' })
            }, [
              _createElementVNode("img", {
                class: "btn",
                src: $setup.liveTimeDownloadBtn,
                onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.liveTimeDonwApp())),
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_48),
              ($setup.live_jump_closable != 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "offbtn",
                    src: $setup.offArterBtn,
                    alt: "",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.closeLiveTimeDownApp()))
                  }, null, 8 /* PROPS */, _hoisted_49))
                : _createCommentVNode("v-if", true)
            ], 6 /* CLASS, STYLE */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["show"]))
      : _createCommentVNode("v-if", true),
    ($setup.standalone && $setup.liveTimeDownload)
      ? (_openBlock(), _createBlock(_component_van_overlay, {
          key: 2,
          show: $setup.standalone && $setup.liveTimeDownload,
          "z-index": "99999"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", { innerHTML: $setup.live_jump_info }, null, 8 /* PROPS */, _hoisted_53)
                  ]),
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.liveTimeDonwApp()))
                  }, "立即升级")
                ])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["show"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 红包广告 "),
    _createVNode(_component_van_overlay, {
      show: $setup.alertRB && $setup.isZb,
      "z-index": "99999",
      onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => ($setup.alertRB = false), ["stop"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "showRB",
          onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            class: "bg",
            style: _normalizeStyle({ backgroundImage: 'url(' + $setup.plany_rb_bg + ')' })
          }, [
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('me.gxni')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, _toDisplayString($setup.playHbPrice), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("img", {
                  src: $setup.play_ktx,
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_58),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.yuan')), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("img", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.oppenRb())),
              class: "btn",
              src: $setup.play_bt,
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_59),
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('me.gxsssni')), 1 /* TEXT */)
          ], 4 /* STYLE */),
          _createElementVNode("div", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.offRb())),
            class: "offBtn"
          }, [
            _createElementVNode("img", {
              src: $setup.offArterBtn,
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_61)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_van_overlay, {
      show: $setup.alertMatchShare,
      onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.alertMatchShare = false)),
      "z-index": "99999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("img", {
              src: $setup.matchShare,
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_64),
            _createElementVNode("div", {
              class: "copyLink",
              onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.copyclsaa('copyLink', $setup.getUrl())))
            }, [
              _createElementVNode("div", _hoisted_65, _toDisplayString($setup.getUrl()), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('play.copyline')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("img", {
            class: "offbtn",
            src: $setup.offArterBtn,
            alt: "",
            onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.alertMatchShare = false))
          }, null, 8 /* PROPS */, _hoisted_67)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _withDirectives(_createElementVNode("div", {
      class: "rightListBox",
      style: _normalizeStyle({ 'bottom': $setup.standalone ? '80px' : '50px' }),
      ref: "drawable"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityDatas, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id
        }, [
          _createElementVNode("img", {
            class: _normalizeClass('downBox2' + (item.cover.indexOf('.png') > 0 ? ' png' : '')),
            onClick: ($event: any) => ($setup.onActivityClick(item)),
            src: item.cover,
            alt: ""
          }, null, 10 /* CLASS, PROPS */, _hoisted_68)
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createCommentVNode(" <div class=\"posBox liveLimit\" v-if=\"isZb\" @click=\"onChatZhuboClick()\">\n      <img :src=\"onmsg\" class=\"onmsg\" />\n      <img class=\"pos showToZbImg\" v-show=\"!showOnMsg\" :src=\"posmsgtop\" alt=\"\" />\n      <img class=\"pos sxlaile\" v-show=\"!showOnMsg\" :src=\"sxlai\" alt=\"\" />\n      <van-badge v-show=\"showOnMsg\" :content=\"redNum\" max=\"99\" class=\"badge\" />\n    </div> ")
    ], 4 /* STYLE */), [
      [_vShow, $setup.active == 'chatroom']
    ]),
    _createCommentVNode(" 有人私聊来了动画 "),
    _createVNode(_Transition, {
      name: "slide-fade",
      mode: "out-in",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "newMsgAnimation",
          onClick: $setup.toMessagePage
        }, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", null, [
              _createVNode(_component_van_image, {
                width: "40",
                height: "40",
                fit: "cover",
                src: $setup.newMsgUser.url,
                round: ""
              }, null, 8 /* PROPS */, ["src"])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, _toDisplayString($setup.newMsgUser.name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('me.sedmsg')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('me.chakan')), 1 /* TEXT */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.showNewMsgAnimation && $setup.active == 'chatroom']
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" <div class=\"linebox\" v-show=\"openLiveUrlBox\">\n                                  <div v-for=\"(item,index) in liveUrlList\" @click=\"changeLineFn(item,index)\">线路{{index+1}}</div>\n                                </div> "),
    _createVNode(_component_van_action_sheet, {
      show: $setup.openLiveUrlBox,
      "onUpdate:show": _cache[23] || (_cache[23] = ($event: any) => (($setup.openLiveUrlBox) = $event)),
      description: $setup.t('tips.changeLine'),
      actions: $setup.liveUrlList,
      "cancel-text": $setup.t('tips.cancel'),
      "close-on-click-action": "",
      onCancel: $setup.onCancel,
      onSelect: $setup.changeLineFn
    }, null, 8 /* PROPS */, ["show", "description", "actions", "cancel-text"]),
    _createCommentVNode(" <div v-if=\"showAlertUser\" class=\"alretUserBox\">\n                                  <div class=\"left\">\n                                    <van-image class=\"img\" fit=\"cover\" :src=\"alertUserData.a\" round></van-image>\n                                    <van-image class=\"zb\" :src=\"roomZb\" round></van-image>\n                                  </div>\n                                  <div class=\"content\">\n                                    <div class=\"name\">{{ alertUserData.n }}</div>\n                                    <div class=\"sub van-multi-ellipsis--l2\">{{ alertUserData.t }}</div>\n                                  </div>\n                                  <div class=\"start\" @click=\"toStart()\">+ 关注</div>\n                                  <van-icon name=\"clear\" class=\"icon\" color=\"#666\" @click=\"() => showAlertUser = false\" />\n                                </div> ")
  ], 64 /* STABLE_FRAGMENT */))
}